import Model from './model.js';
import FileInfo from './fileInfo.js';

export default class Passport extends Model
{
    constructor(id, personId, passportCode, passportIssuer, expireDate, file = null){ 
        super()
        this.id                 = id ?? 0;
        this.personId           = personId;
        this.passportCode       = passportCode;
        this.passportIssuer     = passportIssuer;
        this.expireDate         = expireDate;
        this.file               = file ?? new FileInfo();

        this.init()
    }

    update(data){
        Object.assign(this, data)
    }

    setBinaryFile(binaryFile){
        if (!this.file || typeof this.file !== 'object') this.file = new FileInfo();
        this.file.binaryFile = binaryFile ?? null;
    }

    mapToUpdate(){
        let formData = new FormData();
        formData.append('passportCode', this.passportCode ?? "")
        formData.append('passport_issuer_id', this.passportIssuer?.value ?? "")
        formData.append('expireDate', this.expireDate ?? "")
       
        if (this.file?.binaryFile) formData.append('file', this.file?.binaryFile)

        return formData;
    }

    mapToCreate(){
        let formData = this.mapToUpdate();
        formData.append('person_id', this.personId ?? null)
        
        return formData;
    }
}

